import React from "react";
import { Button } from "reactstrap";

const GeneratePDF = ({ heading, t, fileUrl }) => {
  // ========= IF WE ALREADY HAVE A FILE URL → DOWNLOAD DIRECT FILE =========
  const handleDirectDownload = () => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `${heading}.pdf`;
    link.click();
  };

  // ========= IF THERE IS A FILE URL — STOP AND JUST DOWNLOAD IT =========

  return (
    <Button size="sm" color="primary" onClick={handleDirectDownload}>
      {t("Download")}
    </Button>
  );
};

export default GeneratePDF;
